import '../style.css';
import { initMap } from './map.js';
import { setupGeolocation } from './geolocation.js';

const map = initMap();
setupGeolocation(map);
